import type { AppRoute } from "@/lib/routing";
import { InventoryPage } from "./pages/InventoryPage";

// Owner: C3 (inventory, imports and search). Paths follow spec §9.1.
export const routes: AppRoute[] = [
  {
    path: "/inventory",
    element: <InventoryPage />,
    handle: { title: "Inventory", keywords: ["stock", "lots", "shelves", "low stock", "reorder"] },
  },
  {
    path: "/inventory/receive",
    lazy: async () => ({ Component: (await import("./pages/ReceivePage")).ReceivePage }),
    handle: { title: "Receive stock", keywords: ["delivery", "check in", "weigh", "order arrived", "new lot"] },
  },
  {
    path: "/inventory/receive/:orderId",
    lazy: async () => ({ Component: (await import("./pages/ReceiveOrderPage")).ReceiveOrderPage }),
    handle: {
      title: "Receive a parcel",
      keywords: ["parcel", "delivery", "walk through", "photograph", "check in", "receive order"],
    },
  },
  {
    path: "/inventory/orders/:orderId",
    lazy: async () => ({ Component: (await import("./pages/OrderPage")).OrderPage }),
    handle: { title: "Order", keywords: ["on order", "ordered", "delivery", "parcel", "check in", "receive"] },
  },
  {
    path: "/inventory/stocktake",
    lazy: async () => ({ Component: (await import("./pages/StocktakePage")).StocktakePage }),
    handle: { title: "Stocktake", keywords: ["count", "weigh", "audit", "inventory count"] },
  },
  {
    path: "/inventory/locations",
    lazy: async () => ({ Component: (await import("./pages/LocationsPage")).LocationsPage }),
    handle: { title: "Locations", keywords: ["shelves", "storage", "boxes", "fridge", "racks", "slots"] },
  },
  {
    path: "/lots/:code",
    lazy: async () => ({ Component: (await import("./pages/LotPage")).LotPage }),
    handle: { title: "Lot" },
  },
];
